import { usePendingUpdates } from 'providers/UpdatesProvider/UpdatesProvider'
import { ReactElement } from 'react'
import Styles from './PendingUpdatesContainer.module.scss'
import { UpdateModalsWidget } from 'components/UpdateModalsWidget/UpdateModalsWidget'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const PendingUpdatesContainer = ({ noPendingUpdatesContent }: { noPendingUpdatesContent: ReactElement }) => {
  const pendingUpdates = usePendingUpdates()
  const isAPMobileWeb = useAPMobileWeb()

  if (pendingUpdates.length === 0 || isAPMobileWeb) {
    return noPendingUpdatesContent
  }

  return (
    <div className={Styles.pendingUpdatesContainer}>
      <UpdateModalsWidget />
    </div>
  )
}
